import { Commit } from 'vuex';
// import store from './store';

export const fetchRequest = (
  url: string | {url: string; data: RequestInit},
  cb: CallableFunction,
  onError: CallableFunction | null,
): Promise<unknown> => {
  const data = typeof url === 'string' ? {} : url.data;
  return fetch(typeof url === 'string' ? url : url.url, data)
    .then((response) => {
      if (response.status !== 200) return onError && onError();

      return response.json();
    })
    .then(
      (response) => new Promise((resolve) => {
        resolve(cb(response));
      }),
    )
    .catch((error) => {
      if (onError) onError(error);
    });
};

interface UrlParams<T> {
  [key: string]: T;
}
export const buidlURL = (
  location: string,
  params: UrlParams<string>,
): string => {
  const url = new URL(location);

  Object.keys(params).forEach((key) => {
    url.searchParams.append(key, params[key]);
  });

  return encodeURI(url.toString());
};

export const GATEWAY = 'https://well.ru/local/modules/tour.vitrine/gateway.php';
export const GATEWAY_FOLDER = 'https://well.ru/local/modules/tour.vitrine/';

interface FetchOptions {
  method: string;
  body: FormData;
}
export function loadFetch(
  text: string,
  options: UrlParams<string> | FetchOptions,
  body: CallableFunction,
  commit: Commit,
): Promise<unknown> {
  // commit('setError');
  // const { commit } = store;
  commit('setLoading', { text });
  const url = 'method' in options && 'body' in options
    ? { url: GATEWAY, data: options }
    : buidlURL(GATEWAY, options as UrlParams<string>);
  return fetchRequest(
    url,
    (response: string) => body(response),
    (error: string) => commit('setError', error),
  ).then((response) => {
    commit('setLoading', { text, set: false });
    return response;
  });
}
export function fetchFactory(
  commit: Commit,
) {
  return (
    text: string,
    options: UrlParams<string> | FetchOptions,
    body: CallableFunction,
  ) => loadFetch(
    text,
    options,
    body,
    commit,
  );
}

const pressed: number[] = [];
let lastID = 0;
export const invokeOnce = (callback: CallableFunction, timeout: number) => {
  lastID += 1;
  const localID = lastID;
  pressed.push(localID);

  return setTimeout(() => {
    const localPressed = [...pressed];
    const go = localPressed.length === 1 && localPressed[0] === localID;
    pressed.splice(pressed.indexOf(localID), 1);
    return go ? callback() : false;
  }, timeout);
};

interface I18NObject<T> {
  [key: string]: T;
}
interface I18N {
  month: string[];
  day: string[];
  errors: I18NObject<string>;
  loading: I18NObject<string>;
}
export const i18n: I18N = {
  month: [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
  ],
  day: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
  errors: {
    'Access denied': 'Доступ запрещен',
    'Error getting Request Id': 'Поиск не удался, неверно заполнены поля',
    'No hotel photos': 'Фото отеля отсутствует',
  },
  loading: {
    Initialization: 'Инициализирую',
    'Getting countries': 'Открываю страны',
    'Saving config': 'Сохраняю настройки',
    Searching: 'Ищу туры',
    'Getting result': 'Загружаю туры',
    'Getting hotel info': 'Узнаю об отеле',
    'Actualizing tour': 'Уточняю актуальность тура',
    'Actualizing tour details': 'Уточняю актуальность цен тура',
    // 'It was saved!': 'Оно сохранилось!',
  },
};
export const localeDate = (date: Date, returnYear = false): string => [
  date.getDate(),
  i18n.month[date.getMonth()].slice(0, 3).toLowerCase(),
  returnYear ? date.getFullYear() : '',
]
  .join(' ')
  .trim();
export const dateFromString = (dmY: string): Date => {
  const date = parseInt(dmY.slice(0, 2), 10);
  const month = parseInt(dmY.slice(3, 5), 10) - 1;
  const year = parseInt(dmY.slice(6, 10), 10);
  return new Date(year, month, date);
};
export const stringFromDate = (date: Date): string => `${(`0${date.getDate()}`).slice(-2)}.${(
  `0${
    date.getMonth() + 1}`
).slice(-2)}.${date.getFullYear()}`;
export const isValidEmail = (emailAddress: string): boolean => {
  const pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
  return pattern.test(emailAddress);
};
export const repareHTML = (text: string): string => text
  .replace(/&lt;/g, '<')
  .replace(/&gt;/g, '>')
  .replace(/&quot;/g, '"');
export const repareContext = (text: string, context: string): string => (context === 'pm' || context === 'main-pm'
  ? text.replace(/велл/gi, 'ПутевкаМаркет')
  : text);
export const repareLinks = (text: string, context: string): string => (context === 'pm' || context === 'main-pm'
  ? text.replace(/<a.*?href="\/.*?">(.*?)<\/a>/g, '$1')
  : text.replace(
    /<a(.*?)href="\//g,
    '<a$1target="_blank" href="//well.ru/',
  )
).replace(/<img(.*?)src="\//g, '<img$1target="_blank" src="//well.ru/');

export const details = {
  placement: 'Местоположение',
  // phone: 'Телефон',
  // site: 'Сайт',
  build: 'Год постройки',
  repair: 'Год последнего ремонта',
  square: 'Площадь',
  description: 'Описание',
  territory: 'На территории',
  inroom: 'В номере "Стандарт"',
  services: 'список услуг',
  servicefree: 'Бесплатные услуги',
  servicepay: 'Платные услуги',
  animation: 'Развлечения',
  child: 'Детям',
  beach: 'Пляж',
  meallist: 'Питание',
};
